import { Link } from "react-router-dom";
import { imgSet, imgUrl } from "@/lib/content";

export const isVideo = (src) => /\.(mp4|webm|mov)(\?|$)/i.test(src || "");

export const Media = ({ src, alt = "", w = 800, sizes, className, priority, testId }) => {
  if (!src) return null;
  if (isVideo(src)) {
    return <video className={className} src={imgUrl(src)} autoPlay muted loop playsInline preload="metadata" aria-label={alt} data-testid={testId} />;
  }
  return <img className={className} src={imgUrl(src, w)} srcSet={imgSet(src)} sizes={sizes} alt={alt}
    loading={priority ? undefined : "lazy"} fetchPriority={priority ? "high" : undefined} data-testid={testId} />;
};

export const SmartLink = ({ to, className, children, testId, onClick }) => {
  if (!to) return null;
  if (to.startsWith("/")) return <Link to={to} className={className} data-testid={testId} onClick={onClick}>{children}</Link>;
  const ext = /^https?:/.test(to);
  return <a href={to} className={className} data-testid={testId} onClick={onClick} {...(ext ? { target: "_blank", rel: "noreferrer" } : {})}>{children}</a>;
};
